import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RouteName } from '@mews-commander/enums';
import { CompanyDetail, CompanyDetailTabs } from '@mews-commander/modules/src/modules/companyDetail';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const { id: companyId } = Route.useParams();
    const { tab } = Route.useSearch();

    return (
        // @ts-expect-error CompanyDetail has incorrect types
        <CompanyDetail activeTab={tab} companyId={companyId} scope={companyId} />
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Company/Dashboard/$id')({
    component: Component,
    validateSearch: z.object({
        tab: z.nativeEnum(CompanyDetailTabs).optional().default(CompanyDetailTabs.Dashboard),
        billId: z.string().uuid().optional(),
    }),
    staticData: {
        routeName: RouteName.CompanyDashboard,
        owner: MewsTeam.Accounts,
        type: RouteType.Frontend,
    },
});
